exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (min-width: 790){\r\n\t.navOpen{\r\n\t\tdisplay: block;\r\n\t\ttransition: 1s;\r\n\t\theight: auto;\r\n\t\tmin-height: 200px;\r\n\t}\r\n\r\n\t.navClose{\r\n\t\ttransition: 1s;\r\n\t\theight: 0px;\r\n    \toverflow: hidden;\r\n\t}\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Domin/OneDrive/Proyectos/GyCPlaza/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main